"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _anchor = _interopRequireDefault(require("../../styles/anchor"));
var _LinkButton = require("../../components/LinkButton/LinkButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var StyledA = _styledComponents["default"].a.withConfig({
  displayName: "Anchor__StyledA",
  componentId: "sc-rmtthv-0"
})(["", ""], _anchor["default"]);
var Anchor = function Anchor(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(StyledA, _extends({}, (0, _LinkButton.secureExternalLink)(props.href), props), children);
};
Anchor.propTypes = {
  href: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired,
  color: _propTypes["default"].oneOf(['dark', 'white'])
};
var _default = exports["default"] = Anchor;